import { SuspensionBanner } from "./SuspensionBanner";

export default SuspensionBanner;
